import { render, staticRenderFns } from "./CommonSelect.vue?vue&type=template&id=18bf33a6"
import script from "./CommonSelect.vue?vue&type=script&lang=js"
export * from "./CommonSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports